import { useState } from 'react';
import './leaders-view.styles.scss';
import { Link } from 'react-router-dom';
import { LEADER_CATEGORIES, formatLeaderValue } from '@shared/leaderCategories.js';
import { positions } from '@/utils/positions';
import TeamBadge from '@/components/SHARED/team-badge/team-badge.component';
import TeamLeaders from './team-leaders.component';

// Stat leaders, players or teams. leaders: summary/leaders; teamStats:
// summary/teamStats; teams: summary/teams `teams` map. chemistry (hidden
// team chemistry) is for admin tools only.
const LeadersView = ({ leaders, teamStats, teams, teamLink, playerLink, highlightId, chemistry }) => {

    const [ view, setView ] = useState('players');
    // Leaders saved before a category existed (past seasons, or a league
    // not simmed since) have no list for it: leave its chip out.
    const saved = leaders?.categories ?? {};
    const shown = Object.keys(saved).length ? LEADER_CATEGORIES.filter(c => saved[c.key]) : LEADER_CATEGORIES;
    const [ category, setCategory ] = useState(LEADER_CATEGORIES[0].key);
    const cat = LEADER_CATEGORIES.find(c => c.key === category);
    const rows = leaders?.categories?.[category] ?? [];

    return (
        <div className='leaders-view'>
            <div className='view-switch' role='tablist' aria-label='Leaders'>
                {[['players', 'Players'], ['teams', 'Teams']].map(([key, label]) => (
                    <button key={key} role='tab' aria-selected={view === key}
                        className={view === key ? 'active' : ''}
                        onClick={() => setView(key)}>
                        {label}
                    </button>
                ))}
            </div>
            {view === 'teams' ?
                <TeamLeaders teamStats={teamStats} teams={teams} teamLink={teamLink}
                    highlightId={highlightId} chemistry={chemistry} /> :
                <>
                    <div className='category-chips' role='tablist' aria-label='Stat'>
                        {shown.map(c => (
                            <button
                                key={c.key}
                                role='tab'
                                aria-selected={c.key === category}
                                className={`chip ${c.key === category ? 'active' : ''}`}
                                onClick={() => setCategory(c.key)}>
                                {c.label}
                            </button>
                        ))}
                    </div>
                    {rows.length === 0 ?
                        <p className='meta'>Leaders appear once games have been played.</p> :
                        <div className='g-card'>
                            <div className='table-scroll'>
                                <table className='g-table leaders-table'>
                                    <thead>
                                        <tr>
                                            <th className='num'>#</th>
                                            <th>Player</th>
                                            <th>Team</th>
                                            <th className='num'>GP</th>
                                            <th className='num'>{cat.short}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((r, i) => {
                                            const team = teams?.[r.teamId];
                                            return (
                                                <tr key={r.playerId} className={r.teamId === highlightId ? 'highlight' : ''}>
                                                    <td className='num'>{i + 1}</td>
                                                    <td>
                                                        {playerLink ? <Link to={playerLink(r.teamId, r.playerId)}><b>{r.name}</b></Link> : <b>{r.name}</b>} <span className='meta'>{positions[r.pos - 1]?.short}</span>
                                                    </td>
                                                    <td>
                                                        <Link to={teamLink(r.teamId)} className='team-link' title={team?.name}>
                                                            <TeamBadge team={team} size='sm' />
                                                            <span className='team-abbr'>{team?.abbr}</span>
                                                        </Link>
                                                    </td>
                                                    <td className='num'>{r.gp}</td>
                                                    <td className='num value'>{formatLeaderValue(cat, r.value)}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </>
            }
        </div>
    )
}

export default LeadersView
